// import React from 'react'
// import avatar from "./av.gif"
// import {AiOutlineFile} from 'react-icons/ai';
import {BsTelephoneFill} from 'react-icons/bs';
import { FaFacebook, FaMapMarkerAlt, FaTiktok } from "react-icons/fa";
import {MdEmail} from 'react-icons/md';
import { MdLocationOn, MdContactPhone, MdAccessTime, MdContactMail } from "react-icons/md";
import gg from './../contact-2.png'

// export const Contact2 = (props) => {

//   
//   function hide(){
//     document.getElementById("drop").checked = false;document.getElementById('bar').classList.remove("d-none");document.getElementById('bar2').classList.add("d-none");
//   }

//   return (
//     <div id="contact2"  className="" style={{ marginTop: '50px' }}>
//   <div className="" >
//   <div className="text-center">
// <div className="section-title" style={{marginBottom:'18px'}}>
//           <br/>
//           <h2 style={{color: "white"}}>Contact </h2>
//         </div>
//         </div>
//       <div className="" style={{display:"flex",justifyContent:'center'}}>

//       <div className="" >
//       <div className=" " style={{ fontSize: '18px' }}>
//         <p className='text-center'><MdEmail size={20} style={{ color: '#0256ff' ,position:'relative',top:'4px',right:'3px'}} /> <a href="mailto:cleanexpert4@gmail.com" className="text-white text-center" style={{fontSize:'19px'}}>cleanexpert4@gmail.com</a></p>
//         <p className='text-center'><BsTelephoneFill size={20} style={{ color: '#0256ff' ,position:'relative',top:'4px',right:'3px'}}  /> <a href="tel:+330622045412" className="text-white" style={{fontSize:'19px'}}>+33 06 22 04 54 12</a></p>
//         <p className='text-center'><FaFacebook size={20} style={{ color: '#0256ff' ,position:'relative',top:'4px',right:'3px'}} /> <a href="https://www.facebook.com/profile.php?id=61568559103356" target="_blank" className="text-white" style={{fontSize:'19px'}}>Clean Expert</a></p>
//         <p className='text-center'><FaMapMarkerAlt size={20} style={{ color: '#0256ff' ,position:'relative',top:'4px',right:'3px'}} /> <a href="https://maps.app.goo.gl/UNQYzJbHTdVfcEgDA" target="_blank" className="text-white" style={{fontSize:'19px'}}>64 Rue de Bourgoin , 38230 , Tignieu Jameyzieu</a></p>
//       </div>
//       </div>
//     </div>


//     <div className="text-center">
//       <img src={avatar} className="img-responsive center-block avatar" alt="avatar" />
//     </div>


//   </div>

//   <div className="text-center text-white" style={{ marginTop: '30px' ,fontSize:'19px'}}>
//     © Copyright {year}. Tous droits réservés.
//   </div>
// </div>

//   )
// }

import React from "react";
import { useHistory } from "react-router-dom";
import "./Footer.css";
import logo from './../logo.png';

export const Contact2 = (props) => {
  var year = new Date().getFullYear();
  const history = useHistory();

  const handleDevisClick = () => {
    if (window.location.pathname.startsWith('/service/')) {
      history.push('/#Devis');
    } else {
      const element = document.querySelector('#Devis');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <>
    <div className="contact2-section" id="contact2" style={{backgroundColor:'#111827'}}>
      <footer className="footer-new-layout">
        {/* Left Column: Adresse + Contact merged */}
        <div className="footer-column footer-left">
          <div className="footer-contact-card">
            <div className="footer-contact-header">
              <div className="footer-contact-icon-wrapper">
                <MdContactMail size={40} />
              </div>
              <h3 className="footer-column-title">Contact</h3>
            </div>
            <div className="footer-links">
              <a href='https://maps.app.goo.gl/noR3GWiyzxfT8voPA' target="_blank" rel="noreferrer" className="footer-link-green">
                <MdLocationOn size={26} style={{marginRight: '12px', flexShrink: 0}} />
                <span>40 Rue René Duchamp<br />38110 Saint-Clair-de-la-Tour</span>
              </a>
              <a href="tel:0616608464" className="footer-link-green footer-phone-link">
                <BsTelephoneFill size={20} style={{marginRight: '12px', flexShrink: 0}} />
                <span>06 16 60 84 64 / 07 81 85 28 61</span>
              </a>
              <a href="mailto:lexpert.immo@hotmail.com" className="footer-link-green">
                <MdEmail size={24} style={{marginRight: '12px', flexShrink: 0}} />
                <span>lexpert.immo@hotmail.com</span>
              </a>
              <div className="footer-social-icons-container">
                <a href="https://www.facebook.com/profile.php?id=61558691984053" target="_blank" rel="noreferrer" className="footer-social-icon-single">
                  <FaFacebook size={22} />
                </a>
                <a href="https://www.tiktok.com/@lexpert.renovation?lang=fr" target="_blank" rel="noreferrer" className="footer-social-icon-single">
                  <FaTiktok size={22} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Center Column: Logo + Text + Button */}
        <div className="footer-column footer-center">
          <div className="footer-logo-wrapper">
            <img src={logo} alt="L'EXPERT RENOVATION" className="footer-logo" />
          </div>
          <p className="footer-description">
            L'EXPERT RÉNOVATION est votre partenaire de confiance pour tous vos projets de rénovation intérieure et extérieure. Notre équipe qualifiée et expérimentée vous accompagne de la conception à la réalisation, en garantissant qualité, respect des délais et satisfaction client.
          </p>
          <button className="footer-devis-button" onClick={handleDevisClick}>
            DEMANDER MON DEVIS
            <span style={{marginLeft: '8px'}}>→</span>
          </button>
          <div className="contact2-map-wrapper">
        <div className="map-header">
          <MdLocationOn size={32} style={{color: '#00d458', marginRight: '12px'}} />
          <h3 className="map-title">Notre localisation</h3>
        </div>
        <iframe
          title="Expert Rénovation Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2793.185582130845!2d5.450726099999999!3d45.56670649999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478b237651774cf7%3A0x67a120ab4c591da0!2sL&#39;EXPERT%20RENOVATION!5e0!3m2!1sfr!2sfr!4v1764846604642!5m2!1sfr!2sfr" 
          width="100%"
          height="450"
          style={{ border: 0, borderRadius: "16px" }}
          allowFullScreen=""
          loading="lazy"
          className='footer-map-iframe'
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
        </div>

        {/* Right Column: Horaires */}
        <div className="footer-column footer-right">
          <div className="footer-contact-card">
            <div className="footer-contact-header">
              <div className="footer-contact-icon-wrapper">
                <MdAccessTime size={40} />
              </div>
              <h3 className="footer-column-title">Horaires d'ouverture</h3>
            </div>
            <ul className="footer-hours-list">
              <li><span>Lundi</span><span>08:00–17:00</span></li>
              <li><span>Mardi</span><span>08:00–17:00</span></li>
              <li><span>Mercredi</span><span>08:00–17:00</span></li>
              <li><span>Jeudi</span><span>08:00–17:00</span></li>
              <li><span>Vendredi</span><span>08:00–17:00</span></li>
              <li><span>Samedi</span><span>08:00–14:00</span></li>
              <li><span>Dimanche</span><span>Fermé</span></li>
            </ul>
          </div>
        </div>
      </footer>

      {/* Map Section */}



    </div>
    <div className="contact2-footer-note text-center text-white"   style={{
    background: "linear-gradient(to right, rgb(40, 40, 40) 0%, rgb(65, 65, 65) 100%)",
    fontSize: "18px",
    fontWeight: "bold",
    paddingBottom: "20px",
    paddingTop: "18px"
  }}>
        © Copyright {year} L'EXPERT RÉNOVATION. Tous droits réservés.
        
      </div>
    </>
  );
};

